module.exports = __webpack_public_path__ + "static/half-elf-1-d158d779eb887ddd64c89ce94123ad4d.png";